// extracted by mini-css-extract-plugin
export var actionButton = "_jn-t";
export var buttonContainer = "_jn-0";
export var buttonContainer2 = "_jn-1";
export var buttonSection = "_jn-2";
export var details = "_jn-3";
export var dropdownItem = "_jn-5";
export var dropdownItemsContainer = "_jn-4";
export var fileInput = "_jn-r";
export var headerButton = "_jn-6";
export var icon = "_jn-7";
export var input = "_jn-8";
export var macroListItem = "_jn-9";
export var mainContent = "_jn-a";
export var microText = "_jn-b";
export var modal = "_jn-w";
export var optionsButton = "_jn-c";
export var paperclip = "_jn-s";
export var pillContent = "_jn-d";
export var preview = "_jn-e";
export var preview2 = "_jn-f";
export var quillEditor = "_jn-q";
export var selectedMacro = "_jn-g";
export var sidebar = "_jn-h";
export var sidebarHeader = "_jn-j";
export var sidebarList = "_jn-i";
export var sidebarListItem = "_jn-k";
export var sidebarSearch = "_jn-l";
export var snoozeDurationWrapper = "_jn-v";
export var statusPillContainer = "_jn-m";
export var tagsContainer = "_jn-n";
export var unselectedMacro = "_jn-o";
export var variable = "_jn-u";
export var wrapper = "_jn-p";